import styled from "styled-components";

export const TabsContainer = styled.div`
  width: 100%;
  margin: 1rem 0;
`;

export const TabsList = styled.div`
  display: flex;
  border-bottom: 2px solid #e2e8f0;
  margin-bottom: 1rem;
`;

export const Tab = styled.button`
  padding: 0.75rem 1.5rem;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${props => props.isActive ? '#3b82f6' : '#64748b'};
  border-bottom: 2px solid ${props => props.isActive ? '#3b82f6' : 'transparent'};
  transition: all 0.2s ease;
  
  &:hover {
    color: #3b82f6;
    background-color: #f8fafc;
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
  }
`;

export const TabContent = styled.div`
  position: relative;
`;

export const TabPanel = styled.div`
  display: ${props => props.isActive ? 'block' : 'none'};
`;